import { BrowserRouter } from "react-router-dom"
import { Container } from "./styles"
import ScrollAnimation from "react-animate-on-scroll"
import DhirenMotwani from "../../assets/Shalaka.png";
import { NavHashLink } from "react-router-hash-link"
import linkedin from '../../assets/linkedin.svg'
import whatsapp from '../../assets/whatsapp.svg'
import Hello from '../../assets/Hello.gif'
import emailIcon from '../../assets/icons8-gmail.svg'
import phoneicon from "../../assets/phone-call.svg"
export function Hero() {
  return (
    <Container id="home">
      <div className="hero-text">
        <ScrollAnimation animateIn="fadeInUp">
          <p>Hello <img src={Hello} alt="Hello" width="20px"/>, I'm</p>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInUp" delay={0.2 * 1000}>
          <h1>Shalaka Wadekar</h1>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInUp" delay={0.4 * 1000}>
          <h3>A Digital Marketer & Account Manager</h3>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInUp" delay={0.6 * 1000}>
          <p className="small-resume">4 Years Experience</p>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInUp" delay={0.8 * 1000}>
          <BrowserRouter>
          <NavHashLink
            smooth
            to="#contact"
            className="button"
            style={{ fontWeight: "800", fontSize: "2rem" }}
          >
            Contact
          </NavHashLink>
          </BrowserRouter>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInUp" delay={1 * 1000}>
      <div className="social-media"><a
        href="https://www.linkedin.com/in/shalaka-wadekar29 "
        target="_blank"
        rel="noreferrer"
      >
        <img src={linkedin} alt="Linkedin" />
      </a>
      <a href="tel:+447741883742">
          <img src={phoneicon} alt="Phone No" />
        </a>
        <a
          href="https://api.whatsapp.com/send/?phone=%2B447741883742&text=Hello+Shalaka,+I+found+your+contact+through+your+portfolio+site.%0A%0A"
          target="_blank"
          rel="noreferrer"
        >
          <img src={whatsapp} alt="Whatsapp" />
        </a>
        <a
          href="mailto:wadekar.shalaka50@gmail.com?subject=Contact%20from%20Portfolio&body=Hello%20Shalaka%2C%0A%0AI%20found%20your%20contact%20through%20your%20portfolio%20site.%20I'm%20interested%20in%20connecting%20with%20you."
          target="_blank"
          rel="noreferrer"
        >
          <img src={emailIcon} alt="Email" />
        </a>
        </div>
        </ScrollAnimation>
      </div>
      <div className="hero-image">
        <ScrollAnimation animateIn="fadeInRight" delay={1 * 1000}>
          <img src={DhirenMotwani} alt="Shalaka Wadekar" />
        </ScrollAnimation>
      </div>
    </Container>
  )
}